<template>
  <div class="mt-6">
    <label class="font-semibold mb-4" for="">Object Fields Mapping</label>

    <div v-if="customObjectFields">
      <div
        class="grid grid-cols-3 gap-4 mt-4 pt-4 border-t-1 border-t-gray-500 items-center"
        v-for="(item, index) in customObjectFields"
        :key="index"
      >
        <div class="text-sm col-span-2">{{ item.name }}</div>
        <div>
          <select
            class="bg-white border rounded-lg p-4 h-auto w-full block text-sm py-1"
            v-model="fieldsMapping[item.name]"
            @change="$emit('change', fieldsMapping)"
          >
            <option value="not_provided">Not Provided</option>

            <option
              v-for="(option, index2) in buildaboxFields"
              :key="index2"
              :value="option.name"
              >{{ option.label }}</option
            >
          </select>
        </div>
      </div>
    </div>

    <Spinner :orange="true" v-else class="mt-4 mx-auto" />
  </div>
</template>

<script>
import Api from "@/api/";
import Spinner from "@/components/common/Spinner.vue";

export default {
  name: "CustomFIeldsMapping",
  props: ["selectedCustomObject", "existingValues"],
  components: { Spinner },
  data() {
    return {
      buildaboxFields: [
        {
          name: "first_name",
          label: "First Name"
        },
        {
          name: "last_name",
          label: "Last Name"
        },
        {
          name: "phone",
          label: "Phone"
        },
        {
          name: "email",
          label: "Email"
        },
        {
          name: "company",
          label: "Company"
        },
        {
          name: "address",
          label: "Address"
        },
        {
          name: "state",
          label: "State"
        },
        {
          name: "zip",
          label: "Zip"
        },
        {
          name: "city",
          label: "City"
        }
      ],

      fieldsMapping: {},

      customObjectFields: null
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.customObjectFields = null;
      await this.loadCustomObjectFields();

      this.fieldsMapping = {};
      this.customObjectFields.map(field => {
        this.fieldsMapping[field.name] = (this.existingValues && this.existingValues[field.name])
          ? this.existingValues[field.name]
          : 'not_provided';
      });

      this.$emit("change", this.fieldsMapping);
    },

    async loadCustomObjectFields() {
      const response = await Api.getCustomObjectFields(
        btoa(this.selectedCustomObject)
      );
      this.customObjectFields = response.data;
    }
  },

  watch: {
    selectedCustomObject(oldVal, newVal) {
      this.init();
    }
  }
};
</script>

<style></style>
